module.exports = __webpack_public_path__ + "img/heart-logo.a2582c46.svg";